export default "__VITE_ASSET__h7L6LL_W__"